var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyTriggers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 260,
    viewBox: "0 0 262 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_885_2729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4082 124.499L68.0753 93.0207L131.823 29.6736L198.139 96.0817L225.562 123.544L130.147 218.347L36.4082 124.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.295 124.022C179.295 150.615 157.683 172.194 131 172.194C104.317 172.194 82.6836 150.615 82.6836 124.022C82.6836 101.422 98.2669 82.4704 119.313 77.2602C123.056 76.3267 126.974 75.8274 131 75.8274C139.88 75.8274 148.216 78.2154 155.355 82.4053C169.676 90.7633 179.295 106.264 179.295 124.022Z",
    stroke: "#0321F8",
    strokeWidth: 7.59524,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.377 117.552L130.346 161.557V124.955H110.431C105.339 124.955 101.856 119.81 103.793 115.099L119.311 77.2602C123.055 76.3267 126.972 75.8274 130.999 75.8274C139.879 75.8274 148.214 78.2154 155.353 82.4053L140.575 106.654H151.261C156.877 106.654 160.315 112.798 157.377 117.552Z",
    fill: "#0321F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.225 25.121L142.225 25.1211L230.175 113.173L240.572 123.586L230.133 133.957L230.485 134.312L230.133 133.957L140.616 222.921L130.175 233.294L119.776 222.879L31.8261 134.805L31.8258 134.805L21.4291 124.414L31.8682 114.043L31.8683 114.043L121.385 25.079L121.385 25.0789L131.826 14.7062L142.225 25.121ZM132.094 39.9364L131.742 39.5835L131.388 39.935L46.7249 124.058L46.3693 124.411L46.7235 124.766L129.907 208.064L130.259 208.417L130.613 208.065L215.276 123.92L215.632 123.567L215.278 123.212L132.094 39.9364Z",
    fill: "#0321F8",
    stroke: "#0FF0DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_885_2729",
    x: 0.720703,
    y: 0,
    width: 260.561,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.18767 0 0 0 0 0.926514 0 0 0 0 0.837852 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_885_2729"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_885_2729",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTriggers);
export default __webpack_public_path__ + "static/media/empty-triggers.2a85176f49f31b63a5a165211ac078b2.svg";
export { ForwardRef as ReactComponent };